import { useAppStarting } from './useAppStarting';
import { useFetchUserAccounts } from './useFetchUserAccounts';

export const useRestrictedPage = () => {
  useAppStarting();
  useFetchUserAccounts();
  // useFetchCatalogSubscriptions();
  // useAccountState();
};
